module.exports = __webpack_public_path__ + "assets/ac98442afc1879e19f69d8a382af81b9.png";